import axios from 'axios';
import store from '../store';
import Swal from 'sweetalert2';

export default function setup() {

    // Set baseURL for APIs
    // axios.defaults.baseURL = 'http://localhost:8080/v1/'
    // axios.defaults.baseURL = 'https://api1.dev-tonenetworks.com/v1/';
    axios.defaults.baseURL = 'https://adminapi1.dev-tonenetworks.com/v1/';

    // Add a request interceptor
    axios.interceptors.request.use(
        function(config) {
            const { token } = store.getters.session;
            //console.log("token : ", token);
            if(token) {
                config.headers.Authorization = `Bearer ${token}`;
                //config.headers.common['Authorization'] = `${localStorage.getItem('token')}`
            }
            return config;
        },
        function(err) {
            //console.log("axios.interceptors.request.use err : ", err);
            //console.log("axios.interceptors.request.use err.response : ", err.response);
            return Promise.reject(err);
        }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
        function (response) {
            //console.log("axios.interceptors.response.use response : ", response);
            return response;
        },
        function (err) {
            //console.log("axios.interceptors.response.use err : ", err);
            //console.log("axios.interceptors.response.use err.response : ", err.response);
            Swal(
                `<span style="color: #f27474;">Request Fail</span>`,
                `There is something wrong on server, <br /> please try again later`,
                `error`
            );
            return Promise.reject(err);
        }
    );

}

const instance = axios.create();
function demo (){
// Override timeout default for the library
// Now all requests using this instance will wait 2.5 seconds before timing out
    instance.defaults.timeout = 2500;

// Override timeout for this request as it's known to take a long time
    instance.get('/longRequest', {
        timeout: 5000
    });
}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js